import config from 'src/config';
import {
  getBodyValidateUser,
  getBodyActivateUser,
  getBodyValidateTransaction,
  getBodyLogs,
  getBodyUpdateRetry
} from '../shared/Utilities/functions';
import { UserRepository } from '../infrastructure/repositories/UsersRepository';
import { ActivationRepository } from '../infrastructure/repositories/ActivationRepository';
import { TransactionRepository } from '../infrastructure/repositories/TransactionsRepository';
import { BfkeyRepository } from '../infrastructure/repositories/BfkeyRepository';
import { LogsRepository } from '../infrastructure/repositories/LogsRepository';
import { MessagesRepository } from 'src/infrastructure/repositories/MessagesRepository';
import { SessionRepository } from '../infrastructure/repositories/SessionRepository'
import { validateUser } from '../domain/useCases/ValidateUser';
import { activateUser } from '../domain/useCases/ActivateUser';
import { notifyDesktop } from '../domain/useCases/NotifyDesktop';
import { validateTransaction } from '../domain/useCases/ValidateTransaction';
import { updateRetry } from '../domain/useCases/UpdateRetry';
import { getBfKey } from '../domain/useCases/GetBfKey';
import { saveLogs } from '../domain/useCases/SaveLogs';
import { closeSession } from '../domain/useCases/CloseSession';
import { prevalidateUser } from '../domain/useCases/PrevalidateUser';
import { generateBfKeyManual } from 'src/shared/Utilities/cryptoUtils';

export const getPublicKey = async () => getBfKey(BfkeyRepository);

export const validateClientState = async context => {
  const PARAMS = await getBodyValidateUser(context);
  try {
    return await validateUser(UserRepository, context, PARAMS.data, context.challenge);
  } catch (error) {
    return error;
  }
};

export const userActivation = async context => {
  const PARAMS = await getBodyActivateUser(context);
  const processId = config.TEST_MODE === "true"
    ? context.documentNumber
    : context.processId;
  try {
    return await activateUser(ActivationRepository, context, PARAMS.data, processId);
  } catch (error) {
    return error;
  }
};

export const transactionValidation = async context => {
  const PARAMS = await getBodyValidateTransaction(context);
  try {
    return await validateTransaction(TransactionRepository, context, PARAMS.data);
  } catch (error) {
    return error;
  }
};

export const saveUserTries = async context => {
    const PARAMS = await getBodyUpdateRetry(context);
    try {
      return await updateRetry(UserRepository, context, PARAMS.data);
    } catch (error) {
      return error;
    }
};

export const saveClientLogs = async (context, sourceId, origin, result, description = "") => {
  const bodyRequest = await getBodyLogs(context, sourceId, origin, result, description);
  try {
    return await saveLogs(LogsRepository, context, bodyRequest);
  } catch (error) {
    return error;
  }
};

export const sendNotifyDesktop = async context => {
  try {
    const { jwe } = await generateBfKeyManual(context, {
      code: context.code,
    });
    return await notifyDesktop(MessagesRepository, context, { data: context.data, key: jwe });
  } catch (error) {
    return error;
  }
};

export const clearSession = async context => {
  try {
    const { jwe } = await generateBfKeyManual(context, {
      code: context.code,
    });
    return await closeSession(SessionRepository, context, { data: context.data, key: jwe });
  } catch (error) {
    return error;
  }
};

export const prevalidateClient = async context => {
  const PARAMS = await getBodyValidateUser(context);
  try {
    return await prevalidateUser(UserRepository, context, PARAMS.data);
  } catch (error) {
    return error;
  }
};